import { api } from "./api";

export const supportServices = api.injectEndpoints({
  endpoints: (builder) => ({
    getOpenBox: builder.query({
      query: (productId) => `/getOpenboxProductById?id=${productId}`,
      //   providesTags: [""],
    }),
    getWarrentyAndServices: builder.query({
      query: ({ categoryId, subCategory, productId }) =>
        `/getAddonServicesByproductID?category=${categoryId}&subCategory=${subCategory}&productId=${productId}`,
      // providesTags: [""],
    }),
    verifyCaptcha: builder.mutation({
      query: (body) => ({
        url: `/verifyCaptcha`,
        method: "POST",
        body,
      }),
      //   providesTags: [""],
    }),
    getSuggestions: builder.query({
      query: ({ keyword, productOnly = "" }) =>
        `/typehead?keyword=${keyword}&productsOnly=${productOnly}`,
    }),

    getRebatesList: builder.query({
      query: ({
        page = 1,
        limit = 20,
        brandIds = "",
        type = "",
        search,
        categoryIds,
        validUntil,
        isExpired,
        sort,
        order,
      }) =>
        `/getRebatesList?page=${page}&limit=${limit}&brandIds=${brandIds}&type=${type}&search=${search}&categoryIds${categoryIds}&validUntil=${validUntil}&isExpired=${isExpired}&sort=${sort}&order=${order}`,
    }),
    // ********* Using only for delivery details *********
    getItFastFilter: builder.query({
      query: ({
        limit = 20,
        page = 1,
        slug = "",
        brandIds = "",
        isLuxury,
        minPrice = "",
        maxPrice = "",
        onDisplay = "",
        isAvailabilty = "",
        inStore = "",
        fieldIds = "",
        fieldValueIds = "",
        filterSubCategoryId = "",
        categoryIds,
        subCategoryIds,
        subCategory2Ids,
        criteriaId,
        keyword = "",
        tag,
        sort = "",
        order = "",
        rebateIds = "",
        dimensions = "",
        zipCode = "",
        deliveryDate = "",
        onSale = "",
        clearance = "",
        rebateAvailable = "",
        storeId = "",
        deliveryRouteId = "",
        height = "",
        width = "",
        depth = "",
        totalCapacity = "",
        iceCapacity = "",
        dailyIceProduction = "",
        ovenCapacity = "",
        washerHeight = "",
        washerWidth = "",
        washerDepth = "",
        dryerHeight = "",
        dryerWidth = "",
        dryerDepth = "",
        capacity = "",
        setProductCategoryIds="",
      }) => ({
        url: `/getItfastFilter?limit=${limit}&page=${page}&keyword=${keyword}&tag=${tag}&slug=${slug}&isLuxury=${isLuxury}&categoryIds=${categoryIds}&subCategoryIds=${subCategoryIds}&criteriaId=${criteriaId}&subCategory2Ids=${subCategory2Ids}&brandIds=${brandIds}&minPrice=${minPrice}&maxPrice=${maxPrice}&onDisplay=${onDisplay}&isAvailabilty=${isAvailabilty}&fieldIds=${fieldIds}&fieldValueIds=${fieldValueIds}&filterSubCategoryId=${filterSubCategoryId}&sort=${sort}&order=${order}&rebateIds=${rebateIds}&dimensions=${dimensions}&inStore=${inStore}&zipCode=${zipCode}&deliveryDate=${deliveryDate}&onSale=${onSale}&clearance=${clearance}&rebateAvailable=${rebateAvailable}&storeId=${storeId}&deliveryRouteId=${deliveryRouteId}&height=${height}&width=${width}&depth=${depth}&totalCapacity=${totalCapacity}&iceCapacity=${iceCapacity}&dailyIceProduction=${dailyIceProduction}&ovenCapacity=${ovenCapacity}&washerHeight=${washerHeight}&washerWidth=${washerWidth}&washerDepth=${washerDepth}&dryerHeight=${dryerHeight}&dryerWidth=${dryerWidth}&dryerDepth=${dryerDepth}&capacity=${capacity}&setProductCategoryIds=${setProductCategoryIds}`,
      }),
    }),
  }),
});

export const {
  useGetOpenBoxQuery,
  useVerifyCaptchaMutation,
  useGetWarrentyAndServicesQuery,
  useGetSuggestionsQuery,
  useGetRebatesListQuery,
  useGetItFastFilterQuery,
} = supportServices;
